export default __webpack_public_path__ + "static/media/error-icon.216794a0.svg";